module.exports = "/images/club-apps-brand-white.svg?56de04c6488bdfa63c5049ceec9b9e8a";